import React from "react";

import { useTranslation } from "react-i18next";

import { useLocation } from "react-router-dom";

import { LinkContext } from "../LinkProvider";
import { useContext } from "react";

function Button ( { className } ) {

    const { t } = useTranslation();

    const { link } = useContext(LinkContext);

    const location = useLocation();

    return(
        <div className={className}>
            <a href={`${link}/en/register`}>
                <div className={`px-[32px] py-[16px] flex items-center justify-center bg-[#35AB33] rounded-[60px] hover:scale-[0.95] transition-all`}>
                    <p className={`uppercase ibm-plex text-white text-[14px] xl:text-[16px]`}>{t('main.4')}</p>
                </div>
            </a>
        </div>
    );
}

export default Button;